import axios from 'axios';
import { JsonConvert, OperationMode, ValueCheckingMode } from "json2typescript";
import { IdentityServerDAO } from "@/API/DAO/IdentityServerDAO";
import { ProfileResponse } from "@/API/Models/Account/Responses/ProfileResponse";
export class ProfileDAO {
    static async createProfile(newProfile) {
        console.log('New Profile: ' + JSON.stringify(newProfile));
        let jsonConvert = new JsonConvert();
        jsonConvert.operationMode = OperationMode.LOGGING;
        jsonConvert.ignorePrimitiveChecks = false;
        jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
        let token = await IdentityServerDAO.getServiceProviderAccessToken();
        let axiosRegisterConfig = {
            headers: {
                Authorization: token,
                "Content-Type": "application/json",
                'Accept': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };
        /* Let's see if username is indicated, if not we will set it to the email address */
        if (newProfile.username === null || newProfile.username === undefined || newProfile.username.trim().length === 0) {
            newProfile.username = newProfile.emailAddress;
        }
        let profileResponse;
        let newProfileResponse = new ProfileResponse();
        try {
            profileResponse = await axios.post(process.env.VUE_APP_API_BASE_URL + '/profile/me', JSON.stringify(jsonConvert.serializeObject(newProfile)), axiosRegisterConfig);
            console.log(profileResponse);
        }
        catch (error) {
            newProfileResponse.successful = false;
            newProfileResponse.message = JSON.stringify(error.message);
        }
        try {
            newProfileResponse = jsonConvert.deserializeObject(profileResponse.data, ProfileResponse);
        }
        catch (error) {
            newProfileResponse.successful = false;
            newProfileResponse.message = 'Failed to interpret response. Error: ' + JSON.stringify(error.response.data.error);
        }
        return newProfileResponse;
    }
}
